module.exports = __webpack_public_path__ + "img/default_store.1e58f145.svg";